import { MemberHashKey } from '../../consts/memberHashKey'

export const getStoredMemberHash = () => {
    return localStorage.getItem(MemberHashKey)
}
